<template>
  <div>
    <div class="d-flex activity-entity">
      <div class="entity-icon-wrapper flex-center">
        <template v-if="entityType === ENTITY_TYPE.INITIATIVE || entityType === ENTITY_TYPE.TASK">
          <b-form-checkbox
            class="ml-2"
            :checked="entity.isDoneAndClosed"
            :disabled="true"
            size="sm"
          ></b-form-checkbox>
        </template>
        <i class="entity-icon" :class="entityMeta.icon" v-else></i>
      </div>
      <router-link
        :to="getEntityHref()"
        class="ml-2 text-primary text-medium-1 entity-title pointer"
        :id="'component-' + uuid"
        v-no-capture
      >
        {{ entityMeta.title }}
      </router-link>
    </div>
    <entity-popover
      v-if="isKrOrInitiativeType"
      :target="'component-' + uuid"
      :entity-type="entityType"
      :goal="goal"
      :kr="keyResult"
      :project="project"
      :parent-initiative-id="entityType === ENTITY_TYPE.TASK && activity.initiative.parentId"
    />
  </div>
</template>

<script>
import ComponentIdMixin from '@/mixins/ComponentIdMixin'
import * as R from 'ramda'
import { BFormCheckbox } from 'bootstrap-vue'
import EntityPopover from '@/components/EntityPopover'
import getActivityEntityType from '@/components/activity/utils/getActivityEntityType'
import { ENTITY_TYPE } from '@/constants/entities'
import ActivityMixin from '@/mixins/ActivityMixin'

/**
 * It shows the entity(goal/kr/initiative) to which the passed activity belong to.
 * On hover of entity title, parent entities are shown in popover. e.g below
 *
 * ------------|------------------
 * ENTITY      | PARENT ENTITY
 * ------------|------------------
 * goal        | <None>
 * ------------|------------------
 * KR          | Key Result
 * ------------|------------------
 * Project     | Project
 * ------------|------------------
 * Initiative  | Key Result, Goal
 */
export default {
  name: 'ActivityEntity',
  props: ['activity', 'goal', 'project'],
  mixins: [ActivityMixin, ComponentIdMixin],
  components: {
    EntityPopover,
    BFormCheckbox
  },
  data() {
    return {
      ENTITY_TYPE,
      activityEntityType: getActivityEntityType(this.activity)
    }
  },
  computed: {
    isKrOrInitiativeType() {
      return [ENTITY_TYPE.TASK, ENTITY_TYPE.INITIATIVE, ENTITY_TYPE.KEY_RESULT].includes(
        this.activityEntityType
      )
    },
    entityMeta() {
      const meta = {
        [ENTITY_TYPE.GOAL]: {
          icon: 'goal-icon-greyed',
          title: R.path(['goal', 'title'], this.activity)
        },
        [ENTITY_TYPE.KEY_RESULT]: {
          icon: 'kr-icon-greyed',
          title: R.path(['keyResult', 'title'], this.activity)
        },
        [ENTITY_TYPE.INITIATIVE]: {
          title: R.path(['initiative', 'title'], this.activity)
        },
        [ENTITY_TYPE.TASK]: {
          title: R.path(['initiative', 'title'], this.activity)
        }
      }
      return meta[this.activityEntityType]
    },
    keyResult() {
      return this.entity.keyResult || this.activity.keyResult
    },
    teamId() {
      return this.goal.teamId
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.entity-icon-wrapper {
  @include dimension(15px, 15px);
  margin-top: 5px;
}
</style>
